(function () {
  const mq = window.matchMedia('(max-width: 991.98px)');
  let startX = 0, startY = 0, link = null, swiped = false;

  // Load second images as soon as their card is near the screen
  const loader = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('.product-card__image--hover').forEach((img) => {
        img.loading = 'eager';
      });
      loader.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  function scan() {
    if (!mq.matches || !document.body.classList.contains('template-collection')) return;
    document.querySelectorAll('.product-card__image-wrapper--with-hover:not([data-swipe-ready])').forEach((wrap) => {
      wrap.setAttribute('data-swipe-ready', '');
      loader.observe(wrap);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    scan();
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(scan, 150);
    }).observe(document.body, { childList: true, subtree: true });
  });

  // Slide to the other image, in the direction of the swipe (loops)
  function slide(linkEl, direction) {
    const wrap = linkEl.querySelector('.product-card__image-wrapper--with-hover.is-active');
    if (!wrap) return;
    const first = wrap.querySelector('.product-card__image:not(.product-card__image--hover)');
    const second = wrap.querySelector('.product-card__image--hover');
    if (!first || !second || second.tagName !== 'IMG') return;

    const onSecond = linkEl.classList.contains('is-swiped');
    const current = onSecond ? second : first;
    const next = onSecond ? first : second;
    const enterFrom = direction === 'left' ? '100%' : '-100%';
    const exitTo = direction === 'left' ? '-100%' : '100%';

    // Put the next image on the correct side instantly, without animation
    next.style.setProperty('transition', 'none', 'important');
    next.style.transform = `translateX(${enterFrom})`;
    next.getBoundingClientRect(); // apply that position before animating
    next.style.removeProperty('transition');

    // Animate both images
    current.style.transform = `translateX(${exitTo})`;
    next.style.transform = 'translateX(0)';

    linkEl.classList.toggle('is-swiped', !onSecond);
  }

  document.addEventListener('touchstart', (e) => {
    swiped = false;
    if (!mq.matches || !document.body.classList.contains('template-collection')) return;
    link = e.target.closest('.product-card__image-wrapper-link');
    if (!link || !link.querySelector('.product-card__image-wrapper--with-hover.is-active')) {
      link = null;
      return;
    }
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', (e) => {
    if (!link) return;
    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      slide(link, dx < 0 ? 'left' : 'right');
      swiped = true;
    }
    link = null;
  }, { passive: true });

  document.addEventListener('click', (e) => {
    if (swiped && e.target.closest('.product-card__image-wrapper-link')) e.preventDefault();
    swiped = false;
  }, true);
})();